<div class="header-area header-transparent">
  <div class="main-header header-sticky sticky-bar container-fluid">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-auto">
          <img src="resources/img/logo/logo80ConScritta.png" alt="Logo Full Muscle" class="logo" />
        </div>
        <div class="col-auto">
          <h1>
            <a>
              FULL MUSCLE Gym
            </a>
          </h1>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-8">
          <app-menu></app-menu>
        </div>
        <div class="col-12">
          <div class="mobile_menu d-block d-lg-none">
            <div class="slicknav_menu">
              <a href="javascript:void(0);" (click)="toggleCollapseMenu()" aria-haspopup="true" role="button" tabindex="0"
              [ngClass]="isCollapsed ? 'slicknav_btn slicknav_open' : 'slicknav_btn slicknav_collapsed'">
                <span class="sr-only">MENU</span><i class="bi bi-list"></i></a>
                <ul [ngClass]="isCollapsed ? 'slicknav_nav' : 'slicknav_nav slicknav_hidden'" aria-hidden="false" role="menu" style="display: block;">
                  <li><a routerLink="home" (click)="isCollapsed = !isCollapsed">Home</a></li>
                  <li><a routerLink="sedi" (click)="isCollapsed = !isCollapsed">Sedi</a></li>
                  <!-- <li><a href="chi-siamo">Chi siamo</a></li> -->
                  <li><a routerLink="servizi" (click)="isCollapsed = !isCollapsed">Servizi</a>
                  <li><a routerLink="corsi" (click)="isCollapsed = !isCollapsed">Orari corsi</a>
<!--                     <ul class="submenu">
                      <li><a routerLink="sala-pesi" (click)="isCollapsed = !isCollapsed">Sala pesi</a></li>
                      <li><a routerLink="pt" (click)="isCollapsed = !isCollapsed">Personal training</a></li>
                      <li><a routerLink="corsi" (click)="isCollapsed = !isCollapsed">Corsi</a></li>
                      <li><a routerLink="integratori" (click)="isCollapsed = !isCollapsed">Integratori e alimenti per lo sport</a></li>
                    </ul> -->
                  </li>
                  <li><a routerLink="team" (click)="isCollapsed = !isCollapsed">Il nostro team</a></li>
                  <!-- <li><a routerLink="galleria">Galleria</a></li> -->
                  <li><a routerLink="contattaci" (click)="isCollapsed = !isCollapsed">Contattaci</a></li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
